import { useQuery } from 'react-query';

import { privilegeList as queryFn } from 'api/endPoints/privilegeList';

export const useQueryPrivilegesList = () => {
    return useQuery('getPrivilegesList', () => queryFn());
};
